module.exports = "/_next/static/images/section-for-fulfillment-5da4c0490f85587bcf5d8742335e4c3b.png.webp";